export default __webpack_public_path__ + "6ca25f7d28d6960a0c743774dc1aec27.svg";